import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';
import { PipCallBar } from './PipCallBar';

export function PipCallBarManager() {
  const { callList, callAttributes } = usePhoneState();
  const { selectedTaskId } = useInboxState();

  const allCallsHeld = callList.every((call) => call.held);

  return (
    <>
      {callList.map((call) => {
        const attributes = {
          ...callAttributes[call.callId],
          queueIds: callAttributes[call.callId]?.queueIds
            ? [...callAttributes[call.callId].queueIds]
            : [],
          traits: callAttributes[call.callId]?.traits
            ? [...callAttributes[call.callId].traits]
            : [],
        };

        const showSelectedCallBar =
          allCallsHeld &&
          !!selectedTaskId &&
          selectedTaskId === attributes.pcsConversationSid;

        return (
          <PipCallBar
            key={call.callId}
            callState={call}
            show={!call.held || showSelectedCallBar}
          />
        );
      })}
    </>
  );
}
